<template>
<div>
  <div class="columns">
    <div class="column">
      <h4 class="title is-4">{{ scraper.name }}</h4>
      <p>{{ scraper.description }}</p>
    </div>
  </div>
  <div class="columns">
    <div class="column">
      <text-area
        required
        :value="builder.scraper_payload"
        @input="updateScraperPayload"
        description="The payload created below will be fed into the scraper at scan time.">
        Payload
      </text-area>
      <submit-button
        :working="saving"
        @submit="saveScraper"
        left-icon="save">Save</submit-button>
    </div>
    <div class="column is-4">
      <example :scraper="scraper"/>
    </div>
  </div>
</div>  
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import Scraper from '@/store/models/Scraper'
import Example from './Example.vue'

export default {

  components: {
    Example
  },
  
  props: {
    scraper: {
      type: Object,
      default: () => (new Scraper())
    }
  },

  data: () => ({
    saving: false
  }),

  methods: {
    ...mapMutations('scraperBuilder', [
      'updateScraperPayload'
    ]),
    saveScraper() {
      this.saving = false
      this.$store.dispatch(`scraperBuilder/${this.action}`, this.scraper.id).then(() => {
        this.saving = false
        this.$toast.success('Scraper Saved')
        this.$router.push({
          name: 'scrapers'
        })
      }).catch(error => {
        this.saving = false
        this.$toast.error('Whoops, something went wrong')
      })
    }
  },

  computed: {
    ...mapGetters('scraperBuilder', [
      'builder'
    ]),
    action() {
      return this.builder.id ? 'updateScraper' : 'createScraper'
    }
  }

}
</script>